import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { zyephrMenu } from '../data/menu.data';
import { LocalStorageService } from './local-storage.service';
@Injectable({
  providedIn: 'root',
})
export class MenuService {
  menu: Subject<any[]> = new Subject<any[]>();
  childKeyArray = [];
  constructor(private localStorageService: LocalStorageService) {}
  public generateMenu(userRole?: string): void {
    const user: any = this.localStorageService.getItem('user') || {};
    const roleName =
      user && user.role
        ? typeof user.role === 'string'
          ? user.role
          : user.role.name
        : userRole;
    let keysToInclude: any =
      user && user.allowedRoute
        ? user.allowedRoute
        : user && user.role && user.role.permissions
        ? user.role.permissions
        : [];
    if (!Array.isArray(keysToInclude)) {
      keysToInclude = [];
    }
    let mastersAdded = false;
    keysToInclude = keysToInclude.reduce((acc: any, item: any) => {
      if (this.childKeyArray.includes(item)) {
        if (!mastersAdded) {
          acc.push('masters');
          mastersAdded = true;
        }
      }
      acc.push(item);
      return acc;
    }, []);
    //

    const filteredMenu = zyephrMenu
      .filter((item) => keysToInclude.includes(item.key))
      .map((menuItem) => {
        if (keysToInclude.includes(menuItem.key)) {
          return {
            ...menuItem,
            children: menuItem.children.filter((childItem) =>
              keysToInclude.includes(childItem.key)
            ),
          };
        } else {
          return menuItem;
        }
      });

    if (roleName === 'admin') {
      this.menu.next(zyephrMenu);
    } else {
      this.menu.next(filteredMenu);
    }

    // if (userRole === 'admin') {
    //   this.menu.next(etAdminMenu);
    // }
  }
}
